import RoundButton from '@components/button/RoundButton'
import HOMEIMG from '../images/HOMEIMAGE3.svg'
import ClientPageLayout from '@components/page/ClientPageLayout'
import { Divider, Flex, Image, List, Title, rem, Text } from '@mantine/core'
import React from 'react'
import ContentContainer from '@components/container/ContentContainer'
import { Link } from 'react-router-dom'

const Home: React.FC = () => {
    return (
        <>
            <ClientPageLayout pos='relative'>
                <ContentContainer pos='relative' pb={{ lg: 20 }} mt={rem(140)}>
                    <Flex
                        direction='column'
                        w='fit-content'
                        mb={{ xs: 'xl', md: 100 }}
                    >
                        <Title
                            fz={{
                                xs: '2.5rem',
                                sm: '3.5rem',
                                md: '4rem',
                                lg: '5rem',
                            }}
                            c='blue.5'
                            order={1}
                        >
                            เกษียณอย่างมั่นใจ
                        </Title>

                        <Title
                            fz={{
                                xs: '1.4rem',
                                sm: '2rem',
                                md: '2.5rem',
                                lg: '3rem',
                            }}
                            c='fuchasia.5'
                            order={1}
                        >
                            ด้วย MTL Retirement Check
                        </Title>
                        <Divider
                            my='lg'
                            color='gray.3'
                            style={{ maxWidth: '50%' }}
                        />
                        <Title
                            fw={500}
                            fz={{
                                xs: '1.2rem',
                                sm: '2rem',
                                md: '2.5rem',
                                lg: '2.2rem',
                            }}
                            c='fuchasia.5'
                            order={1}
                        >
                            <span style={{ display: 'inline-block' }}>
                                ชีวิตหลังเกษียณที่คุณใฝ่ฝันเป็นอย่างไร ?
                            </span>
                        </Title>

                        <Flex
                            direction={{ xs: 'column', sm: 'column' }}
                            mt='xl'
                        >
                            <Text mb={15}>
                                เชื่อว่าหลายคนคงอยากใช้ชีวิตหลังเกษียณอย่างสบาย
                                โดยไม่ต้องกังวลเรื่องเงิน
                                แต่รู้หรือไม่ว่าการเกษียณอย่างมั่นใจนั้นต้องอาศัยการวางแผนล่วงหน้า
                                ต้องตรวจสอบความพร้อมทางการเงินก่อนการเกษียณ
                                พร้อมวางแผนการออมอย่างเป็นระบบก็สําคัญ เช่นกัน
                            </Text>
                            <Text mb={15}>
                                How much ?
                                แล้วเท่าไหร่ละถึงจะพอให้เราเกษียณอย่างอิสระได้
                                หลายคนที่นึกตัวเลขในใจที่มากพอ
                                และคิดแนวทางความเป็นไปได้ไปต่าง ๆ นานา
                                วันนี้เรามาลองคํานวณตัวเลขคร่าว ๆ
                                <span style={{ display: 'inline-block' }}>
                                    เพื่อประเมินความเป็นไปได้และวางแผนไป
                                </span>{' '}
                                พร้อม ๆ กันอย่างเป็นระบบด้วย MTL Retirement
                                Check กัน...
                            </Text>
                            <Text fz={14}>
                                #เกษียณอย่างมั่นใจ #เกษียณไม่ใช่เรื่องของคนแก่
                                #MTLRetirementCheck
                            </Text>
                        </Flex>

                        <Flex
                            direction={{ xs: 'column', sm: 'row' }}
                            gap='md'
                            mt='xl'
                        >
                            <RoundButton
                                component={Link}
                                to='/calc/employee'
                                label='สำหรับพนักงาน'
                            />
                            <RoundButton
                                component={Link}
                                to='/calc/normal'
                                label='สำหรับบุคคลทั่วไป'
                            />
                        </Flex>

                        <Flex direction={{ base: 'column' }} mt='xl'>
                            <Text fz={12}>
                                *Retirement Check
                                เป็นเครื่องมือคํานวณออนไลน์ที่ช่วยให้คุณวางแผนการเงินสําหรับวัยเกษียณได้อย่างง่ายดาย
                                เพียงกรอกข้อมูลของคุณ เช่น อายุ
                                รายจ่ายที่ต้องการ ใช้หลังเกษียณ
                                และเป้าหมายเกษียณ Retirement Check
                                จะคํานวณว่าคุณต้องออมเงินเท่าไรต่อเดือนเพื่อบรรลุเป้าหมาย
                            </Text>
                            <br />
                            <Text fz={12}>
                                "บริษัท เมืองไทยประกันชีวิต จำกัด (มหาชน)
                                (“บริษัท”) คำนึงถึงความสำคัญของข้อมูล
                                และเคารพสิทธิความเป็นส่วนตัวของท่านโดยบริษัทจะใช้ข้อมูลที่ท่านได้ให้ไว้เพื่อวัตถุประสงค์ในการจัดทำแผนการเงินให้แก่ท่าน
                                และเพื่อจัดทำข้อมูลเชิงสถิติเพื่อวัดผลสัมฤทธิ์ของโครงการ
                                โดยจัดเก็บข้อมูลไว้เป็นระยะเวลา 2 ปี ทั้งนี้
                                ท่านสามารถศึกษารายละเอียดเกี่ยวกับสิทธิต่างๆของท่านได้ที่นโยบายความเป็นส่วนตัวของบริษัทฯ{' '}
                                <a
                                    href='https://www.muangthai.co.th/th/privacy-policy'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    www.muangthai.co.th/th/privacy-policy
                                </a>{' '}
                                "
                            </Text>
                        </Flex>
                    </Flex>
                    <Image
                        pos={{ xs: 'relative', md: 'absolute' }}
                        top={{ base: '-5%' }}
                        mb='xl'
                        ml='-10%'
                        right={{ xs: '-25%', md: '-15%', lg: '-10%' }}
                        src={HOMEIMG}
                        w={{ xs: '110%', md: '450px', lg: '550px' }}
                    />
                </ContentContainer>
                <Flex
                    py='xl'
                    w='100%'
                    pos='relative'
                    mt={'auto'}
                    px={0}
                    bg='gray.6'
                >
                    <ContentContainer py='xl'>
                        <Title c='white' mb='sm' order={4}>
                            หมายเหตุ
                        </Title>
                        <List
                            c='white'
                            fz='xs'
                            listStyleType='none'
                            spacing='8px'
                        >
                            <List.Item>
                                {' '}
                                1)
                                โปรแกรมคำนวณแผนเกษียณอายุถือเป็นการคำนวณเบื้องต้นจากการกรอกข้อมูลของผู้ใช้งานเท่านั้น
                            </List.Item>
                            <List.Item>
                                2)
                                การจัดเก็บข้อมูลการคำนวณเงินเพื่อวางแผนเกษียณอายุจะไม่ถูกเปิดเผย
                            </List.Item>
                        </List>
                    </ContentContainer>
                </Flex>
            </ClientPageLayout>
        </>
    )
}

export default Home
